import { CommonModule } from '@angular/common';
import { Component, forwardRef, inject, signal } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import { Dialog } from '@capacitor/dialog';
import { Share } from '@capacitor/share';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { addHours } from 'date-fns';
import { shareReplay } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { RoomTicket } from 'src/app/models/ticket.model';
import { UsersService } from 'src/app/services/users.service';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';
import { TicketComponent } from '../../ticket/ticket.component';

@Component({
  selector: 'app-kanban-item-view-dialog',
  templateUrl: './item-view.dialog.html',
  styleUrls: ['./item-view.dialog.scss'],
  imports: [
    CommonModule,
    AppCommonModule,
    MainDialogComponent,
    // eslint-disable-next-line @angular-eslint/no-forward-ref
    forwardRef(() => TicketComponent),
  ],
})
export class KanbanItemViewDialogComponent {
  private workerTicketsService = inject(WorkerTicketsService);

  siteGuidS = signal<string>(null);
  roomTicket = signal<RoomTicket>(null);
  segmentValue = signal<string>(null);

  role$ = this.usersService.role$.pipe(
    shareReplay(1),
  );

  showShare = signal(true);

  constructor(
    private _modal: ModalController,
    private translate: TranslateService,
    private usersService: UsersService,
    navParams: NavParams,
  ) {
    this.roomTicket.set(navParams.get('ticket'));
    this.siteGuidS.set(this.roomTicket().site);

    Share.canShare().then((value) => this.showShare.set(value.value));
  }

  onShare() {
    const user = this.usersService.currentUserS();
    const ticket = this.roomTicket();
    Dialog.prompt({
      title: this.translate.instant('tickets.assignEmail'),
      message: this.translate.instant('tickets.giveEmail'),
    }).then((confirmValue) => {
      if (confirmValue?.value?.length > 0) {
        const email = confirmValue.value;
        ticket.contractor = { guid: email, name: email };
        const expiresDate = addHours(new Date(), 48);
        const expires = Timestamp.fromDate(expiresDate);
        ticket.shared = { email, expires };
        const text = this.translate.instant('tickets.acceptedCommercial', { name: user.displayName, org: ticket.contractor.name });
        const history = this.workerTicketsService.createHistory('assigned', text);
        ticket.history.push(history);
        this.workerTicketsService.updateRoomTicket(ticket);
        this.roomTicket.set(ticket);
      }
    });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
